import { PageHeader, StatusChip } from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { OwnerDataTable as DataTable } from "../../components/owner-data-table.tsx";
import { useOwnerState } from "../../features/backoffice/queries.ts";

export const Route = createFileRoute("/_app/incidents")({ component: IncidentsScreen });

function IncidentsScreen() {
  const { data } = useOwnerState();
  return (
    <div className="space-y-6">
      <PageHeader
        title="Incidents"
        subtitle="ModerationReport / Incident overview without unsafe reporter identity disclosure."
      />
      <DataTable
        rows={data?.incidents ?? []}
        getRowKey={(row) => row.id}
        columns={[
          { key: "type", header: "Type", cell: (row) => row.type },
          {
            key: "severity",
            header: "Severity",
            cell: (row) => (
              <StatusChip
                tone={
                  row.severity === "critical"
                    ? "danger"
                    : row.severity === "high"
                      ? "warning"
                      : "info"
                }
              >
                {row.severity}
              </StatusChip>
            ),
          },
          { key: "state", header: "State", cell: (row) => row.state },
          { key: "session", header: "Session", cell: (row) => row.sessionId },
          { key: "summary", header: "Summary", cell: (row) => row.summary },
          { key: "audit", header: "Audit", cell: (row) => row.auditIds.join(", ") },
        ]}
      />
    </div>
  );
}
